export default __webpack_public_path__ + "static/media/brand_pago_despues.1e7a0b8d.svg";